export enum InvestmentsRoutesEnum {
  ONBOARDING = '/cofrinhos/quer-guardar-dinheiro',
  NOT_AVAILABLE = '/cofrinhos/sem-ofertas-disponiveis',
  HOME = '/cofrinhos',
  SIMULATE = '/cofrinhos/simulador',
  CHANGE_PRODUCT = '/cofrinhos/produtos/alterar-produto',
  PRODUCT_DETAILS = '/cofrinhos/produtos/${pid}',
  SAVE = '/cofrinhos/como-quer-guardar',
  SAVE_BY_VALUE = '/cofrinhos/guardar-dinheiro/por-valor',
  SAVE_BY_VALUE_REVIEW = '/cofrinhos/guardar-dinheiro/por-valor/confira-os-dados',
  SAVE_BY_VALUE_PIN = '/cofrinhos/guardar-dinheiro/por-valor/informe-seu-pin',
  SAVE_BY_RECEIVABLES = '/cofrinhos/guardar-dinheiro/por-recebimentos',
  SAVE_BY_RECEIVABLES_REVIEW = '/cofrinhos/guardar-dinheiro/por-recebimentos/confira-os-dados',
  SAVE_BY_RECEIVABLES_PIN = '/cofrinhos/guardar-dinheiro/por-recebimentos/informe-seu-pin',
  SAVE_SELECT_A_BUCKET = '/cofrinhos/guardar-dinheiro/selecione-um-objetivo',
  WITHDRAWAL = '/cofrinhos/resgatar-dinheiro/selecione-um-objetivo',
  BUCKET_CREATE = '/cofrinhos/objetivos/criar',
  BUCKET_DETAILS = '/cofrinhos/objetivos/${bid}',
  BUCKET_PRODUCT = '/cofrinhos/objetivos/${bid}/produtos/${pid}',
  BUCKET_PRODUCTS = '/cofrinhos/objetivos/${bid}/produtos',
  BUCKET_STATEMENT = '/cofrinhos/objetivos/${bid}/extrato',
  BUCKET_EDIT = '/cofrinhos/objetivos/${bid}/alterar',
  BUCKET_RULES = '/cofrinhos/regras',
  BUCKET_RULES_EDIT_BY_RECEIVABLES = '/cofrinhos/regras/alterar/por-recebimentos',
  BUCKET_RULES_EDIT_BY_VALUE = '/cofrinhos/regras/alterar/por-valor',
  INFO_ABOUT_TAXATION = '/investimentos/sobre-tributacao'
}

export enum MarketInvestmentsRoutesEnum {
  PRODUCTS_OFFERS = '/cofrinhos/investimentos/produtos/selecionar-produto',
  PRODUCTS_OFFERS_DETAILS = '/cofrinhos/investimentos/produtos/${pid}',
  DEPOSIT = '/cofrinhos/investimentos/depositar',
  DEPOSIT_REVIEW = '/cofrinhos/investimentos/depositar/confira-os-dados',
  DEPOSIT_PIN = '/cofrinhos/investimentos/depositar/informe-seu-pin',
  INVESTMENTS_DETAILS = '/cofrinhos/investimentos/meus-investimentos',
  PRODUCT_BY_MOVEMENTS = '/cofrinhos/investimentos/meus-investimentos/produtos/${pid}',
  INVESTED_PRODUCTS = '/cofrinhos/investimentos/meus-investimentos/produtos',
  INVESTED_PRODUCTS_STATEMENT = '/cofrinhos/investimentos/meus-investimentos/extrato',
  WITHDRAWAL_SELECT_PRODUCT = '/cofrinhos/investimentos/resgatar/selecione-um-investimento',
  WITHDRAWAL = '/cofrinhos/investimentos/resgatar',
  WITHDRAWAL_PIN = '/cofrinhos/investimentos/resgatar/informe-seu-pin'
}

export enum StoreInvestmentsRoutesEnum {
  DEPOSIT_PRODUCTS_OFFER = '/investimentos/depositar/produtos',
  DEPOSIT_PRODUCTS_OFFER_DETAILS = '/investimentos/depositar/produtos/${pid}'
}

export enum SweepAccountsRoutesEnum {
  HOME = '/rendimentos-saldo',
  ABOUT = '/rendimentos-saldo/sobre'
}

export const accessibleRoutePrefixesOnboarding = [
  InvestmentsRoutesEnum.ONBOARDING,
  InvestmentsRoutesEnum.BUCKET_CREATE,
  InvestmentsRoutesEnum.SAVE,
  InvestmentsRoutesEnum.INFO_ABOUT_TAXATION,
  MarketInvestmentsRoutesEnum.DEPOSIT,
  MarketInvestmentsRoutesEnum.DEPOSIT_REVIEW,
  MarketInvestmentsRoutesEnum.DEPOSIT_PIN,
  '/investimentos/depositar/produtos',
  '/cofrinhos/guardar-dinheiro',
  '/cofrinhos/investimentos/produtos',
  '/cofrinhos/produtos'
]
